import { useCallback, useEffect, useState } from 'react';

export const usePersistentIsHidden = (key: string, initialValue: boolean = false) => {
  const [isHidden, setIsHidden] = useState<boolean>(() => {
    const storedValue = localStorage.getItem(key);
    return storedValue !== null ? JSON.parse(storedValue) : initialValue;
  });

  const toggleHidden = useCallback(() => {
    setIsHidden((hidden) => {
      localStorage.setItem(key, JSON.stringify(!hidden));
      return !hidden;
    });
  }, [key, setIsHidden]);

  useEffect(() => {
    const storedValue = localStorage.getItem(key);
    setIsHidden(storedValue !== null ? JSON.parse(storedValue) : initialValue);
  }, [key, initialValue]);

  return { isHidden, toggleHidden };
};
